module.exports = __webpack_public_path__ + "static/img/11.ecb9527.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/5/zh/11.png
// module id = 84WL
// module chunks = 0